/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Expense_Clear_Duplicate_ErrorInputs */

const vi_toast_expense_clear_duplicate_error = /** @type {(inputs: Toast_Expense_Clear_Duplicate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không cập nhật được`)
};

/**

* @param {Toast_Expense_Clear_Duplicate_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_expense_clear_duplicate_error = /** @type {((inputs?: Toast_Expense_Clear_Duplicate_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Expense_Clear_Duplicate_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_expense_clear_duplicate_error(inputs)
});